import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"

export default (isAdmin?: boolean) => {
	const { t } = useTranslation("services", { keyPrefix: "form.dataTableHeaders.services" })

	return isAdmin !== undefined ? columns(t).filter(c => isAdmin || !c.needsAdmin) : columns(t)
}

const columns = (t: TFunction) => [
	{
		title: "ID",
		dataIndex: "id",
		key: "id",
		sorteable: true,
		width: "5rem"
	},
	{
		title: t("weight"),
		dataIndex: "weight",
		key: "weight",
		sorteable: true,
		width: "5rem"
	},
	{
		key: "service",
		title: t("service"),
		dataIndex: "service",
		width: "20rem"
	},
	{
		key: "user",
		title: t("user"),
		dataIndex: "user",
		filter: true,
		width: "10rem"
	},
	{
		title: t("status"),
		dataIndex: "status",
		key: "status",
		needsAdmin: true,
		filter: true,
		width: "8rem"
	},
	{
		key: "clusters",
		title: t("clusters"),
		dataIndex: "clusters",
		filter: true,
		width: "25rem",
		filterExactText: true
	},
	{
		title: t("crossSelling"),
		dataIndex: "crossSelling",
		key: "crossSelling",
		needsAdmin: true,
		filter: true,
		width: "6rem"
	},
	{
		title: "",
		key: "reviewsButton",
		dataIndex: "reviewsButton",
		width: "3rem"
	},
	{
		title: "",
		key: "editButton",
		dataIndex: "editButton",
		width: "3rem"
	},
	{
		title: "",
		key: "duplicateButton",
		dataIndex: "duplicateButton",
		width: "3rem"
	}
]
